export default {
  formValidation: {
    emptyField: 'Das Feld darf nicht leer sein',
    requiredField: 'Das Feld ist Pflichtfeld',
    passwordToShort: 'Das Passwort muss 8 Zeichen lang sein',
    emailNotValid: 'Das Feld muss eine gültige E-Mail Adresse enthalten',
    emailReserved: 'Die E-Mail-Adresse ist bereits vergeben',
    rateEmpty: 'Alle Felder müssen ausgefüllt werden',
    serverUnknownError: 'Kommunikationsfehler des Servers',
    invalidCharacters: 'Feld enthält ungültige Zeichen',
    phoneNotValid: 'Die Telefonnummer ist falsch',
    checkBoxBelow: 'Bitte kreuzen Sie das Feld unten an, um eine Nachricht zu senden',
  },
  password: {
    show: 'anzeigen',
    hide: 'ausblenden',
  },
  howItWorks: {
    showButton: 'Mehr anzeigen',
    hideButton: 'Weniger anzeigen',
  },
}
